export default {
	"location": "Location",
	"contact": "Contact Us",
	"openHour": "Open Hours"
}
